import PropTypes from 'prop-types';
import * as React from 'react';
import {animated, Transition} from 'react-spring';

import SelectedFilterNode from './SelectedFilterNode';
import styles from './SelectedFilters.less';
import {FilterSchema} from 'src/js/model/filters_config';

const TRANSITION_FROM = {overflow: 'hidden', height: '0px', opacity: 0};
const TRANSITION_ENTER = {height: '49px', opacity: 1};
const TRANSITION_LEAVE = {height: '0px', opacity: 0};

const AnimatedSelectedFilterNode = animated(SelectedFilterNode);

class SelectedFilters extends React.PureComponent {
  static showOperatorAfterItem(item, state, lastItemId) {
    return !lastItemId || item.id === lastItemId || state === 'leave';
  }

  static getTransitionKeys(filter) {
    return filter.id;
  }

  render() {
    const {
      agens,
      autocompleteValues,
      enumMap,
      hierarchyChildrenLabels,
      organizations,
      removeFilter,
      schema,
      selectedFilters,
    } = this.props;

    const currentLastFilterId =
      selectedFilters && selectedFilters.length > 0
        ? selectedFilters[selectedFilters.length - 1].id
        : null;

    return (
      <div className={styles.dlSelectedFilters}>
        <Transition
          items={selectedFilters}
          keys={SelectedFilters.getTransitionKeys}
          from={TRANSITION_FROM}
          enter={TRANSITION_ENTER}
          leave={TRANSITION_LEAVE}
          trail={200}
        >
          {(animatedValues, filter, state) => (
            <AnimatedSelectedFilterNode
              autocompleteValues={autocompleteValues}
              key={filter.id}
              enumMap={enumMap}
              filter={filter}
              animatedStyle={animatedValues}
              removeFilter={removeFilter}
              schema={schema}
              hierarchyChildrenLabels={hierarchyChildrenLabels}
              organizations={organizations}
              agens={agens}
              showOperatorAfter={SelectedFilters.showOperatorAfterItem(
                filter,
                state,
                currentLastFilterId
              )}
            />
          )}
        </Transition>
      </div>
    );
  }
}

SelectedFilters.displayName = 'SelectedFilters';

SelectedFilters.propTypes = {
  autocompleteValues: PropTypes.objectOf(PropTypes.any).isRequired,
  enumMap: PropTypes.objectOf(PropTypes.any).isRequired,
  hierarchyChildrenLabels: PropTypes.objectOf(PropTypes.any),
  organizations: PropTypes.arrayOf(PropTypes.any),
  agens: PropTypes.arrayOf(PropTypes.any),
  removeFilter: PropTypes.func.isRequired,
  selectedFilters: PropTypes.arrayOf(PropTypes.object),
  schema: PropTypes.instanceOf(FilterSchema).isRequired,
};

SelectedFilters.defaultProps = {
  hierarchyChildrenLabels: undefined,
  organizations: undefined,
  agens: undefined,
  selectedFilters: undefined,
};

export default SelectedFilters;
